import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

export type BreadcrumbItem = {
  label?: string;
  icon?: string;
  route?: string;
  params?: Record<string, string>;
};

@Component({
  selector: 'afoone-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css'],
})
export class BreadcrumbComponent implements OnChanges {
  @Input() breadcrumbItems?: Array<BreadcrumbItem>;
  @Input() backUrl?: string;
  @Input() hideBackButton?: boolean = false;
  public items: MenuItem[];

  constructor(
    private _router: Router,
    private _translateService: TranslateService
  ) {}


  ngOnChanges(): void {
    this.items = this.breadcrumbItems?.map((item) => {
      return {
        label: item.label ? this._translateService.instant(item.label) : null,
        icon: item.icon,
        routerLink: item.route,
        queryParams: item.params,
      };
    });
  }

  public goBack(): void {
    if (!this.backUrl) {
      window.history.back();
    } else {
      this._router.navigate([this.backUrl]);
    }
  }

  public navigateTo(item: MenuItem): void {
    if (item.routerLink) {
      // check the ones that are to go back as back(-1) or back(-2)
      if (item.routerLink.includes('back')) {
        const backCount = parseInt(
          item.routerLink.split('back')[1].replace('(', '').replace(')', '')
        );
        if (backCount) {
          window.history.go(backCount);
          return;
        }
      }
      this._router.navigate([item.routerLink], {
        queryParams: item.queryParams,
      });
    }
  }
}
